import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ONBOARDING_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseDownloadPropertyTemplateProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const downloadPropertyTemplate = async (communityId: string) =>
  await axiosAuth.get(`${ONBOARDING_API(communityId)}/properties/template`, {
    responseType: "blob",
  });

const useDownloadPropertyTemplate = ({
  communityId,
  queryParams}: UseDownloadPropertyTemplateProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["download-property-template", communityId],
    queryFn: () => downloadPropertyTemplate(communityId),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useDownloadPropertyTemplate;
